import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Flexbox from 'flexbox-react';
import Select from 'react-select';
import ProcessService from 'services/ProcessService';
import ProcessUtils from 'utils/ProcessUtils';
import Constants from 'utils/Constants';
import { popoverErrorStyle, colorRed } from 'styles/base.js';
import ProcessEditor from 'utils/ProcessEditor';


class SelectGeospatialVariablesForm extends React.Component {
    static propTypes = {
        processId: PropTypes.string,
        process: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.state = {
            value: null
        };
    }

    getGeospatialDatasetValue() {
        return ProcessUtils.getSelectedSelectValue(this.state.value, this.getGeospatialDatasetOptions())
    }

    getGeospatialDatasetOptions() {
        const datasetNames = ProcessUtils.getDatasetsWithGeospatialVariables(this.props.process);
        const options = Constants.convertArrayToSelectOptions(datasetNames);
        options.push({ value: '', label: 'None' });

        return options;
    }

    onSelectChange = (value) => {
        this.setState({ value: value.value })
    };

    render() {
        const component = (
            <Select
                classNamePrefix="react-select"
                value={this.getGeospatialDatasetValue()}
                options={this.getGeospatialDatasetOptions()}
                onChange={this.onSelectChange}
                autoFocus
                isMulti={false}
            />
        );

        return (
            <Flexbox alignItems="center" flexDirection="row">
                <div>Input Dataset Name:</div>
                <div style={ { flexGrow: 1, marginLeft: '5px' } }>
                    {component}
                </div>
            </Flexbox>
        );
    }
}

// Connect to store so that we can get changes when RIE components are modified, even when rendered inside a modal dialog
const mapStateToProps = (storeState, ownProps) => {
    const processId = ownProps.processId;
    const processState = ProcessService.getMyState(storeState);
    const process = processState.workingCopiesById[processId];

    return {
        process
    };
};


export default connect(mapStateToProps, null, null, {forwardRef: true})(SelectGeospatialVariablesForm);



// WEBPACK FOOTER //
// ./src/components/core/forms/SelectGeospatialVariablesForm.js